
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|5715|6687|6945)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
